import React, { forwardRef } from 'react';
import { formatTime } from '@helpers/formatTime';

const durationToSeconds = (duration) => {
    if (!duration) {
        return 0;
    }
    const parts = duration.split(':').map(Number);
    switch (parts.length) {
        case 1: // SS format
            return parts[0];
        case 2: // MM:SS format
            return parts[0] * 60 + parts[1];
        case 3: // HH:MM:SS format
            return parts[0] * 3600 + parts[1] * 60 + parts[2];
        default:
            return 0;
    }
};

const EpisodeLength = forwardRef(({ currentTime, duration, audioDuration }, ref) => {
    const playerDuration = audioDuration ? audioDuration : durationToSeconds(duration);

    return (
        <span className="player-app__time">
            {formatTime(currentTime)} / {formatTime(playerDuration)}
        </span>
    );
});

export default EpisodeLength;
